import en from './en.mjs'

export default Object.freeze({
  ...en,
  'common.language.label': 'Idioma',
  'common.download.action': 'Descarregar',
  'common.store.appleprefix': 'Descarregar na',
  'common.store.googleprefix': 'DISPONÍVEL NO',
  'seo.home.title': 'Happy Pets | Companheiro IA, testes e widgets',
  'seo.home.description': 'Conheça um animal virtual com IA para reflexão diária, testes de personalidade, tarot, sonhos, widgets e criação conjunta com amigos.',
  'seo.home.keywords': 'Happy Pets, companheiro IA, animal virtual, widget, teste de personalidade, MBTI, tarot IA',
  'seo.invite.title': 'Convite Happy Pets | Crie um animal com amigos',
  'seo.invite.description': 'Abra o convite Happy Pets para adotar ou criar um animal virtual com amigos no iPhone e Android.',
  'nav.skills.label': 'Competências',
  'nav.tests.label': 'Testes',
  'nav.guidance.label': 'Orientação IA',
  'nav.features.label': 'Funcionalidades',
  'nav.experience.label': 'Experiência',
  'nav.community.label': 'Comunidade',
  'nav.news.label': 'Notícias',
  'home.hero.titlelead': 'Um pequeno animal,',
  'home.hero.titleaccent': 'uma pequena ajuda todos os dias',
  'home.hero.subtitle': 'Adote um animal virtual acolhedor que vive no seu ecrã, cresce consigo e aprende competências úteis para ajudar, divertir e fazer companhia.',
  'home.tools.eyebrow': 'Competências do animal',
  'home.tools.title': 'Pequenas tarefas diárias em que pode ajudar',
  'home.tools.description': 'Transforme o seu animal num companheiro útil para refletir, pensar em refeições, conhecer a personalidade e tomar decisões quotidianas.',
  'home.tools.action': 'Experimentar',
  'tool.tarot.tag': 'Reflexão',
  'tool.tarot.title': 'Tarot',
  'tool.tarot.description': 'Deixe o seu animal tirar uma carta e ajudá-lo a olhar para a pergunta de outra perspetiva.',
  'tool.mbti.tag': 'Personalidade',
  'tool.mbti.title': 'MBTI',
  'tool.mbti.description': 'Explore o seu tipo, compare padrões e descubra como pensa e se relaciona.',
  'tool.chef.tag': 'Cozinha',
  'tool.chef.title': 'Chef do Frigorífico',
  'tool.chef.description': 'Transforme o que já tem no frigorífico em refeições simples com o seu pequeno chef.',
  'tool.fortune.tag': 'Diário',
  'tool.fortune.title': 'Sorte do dia',
  'tool.fortune.description': 'Comece o dia com uma visão leve do humor, da sorte e dos pequenos momentos que se aproximam.',
  'tool.calorie.tag': 'Saúde',
  'tool.calorie.title': 'Calculadora de calorias',
  'tool.calorie.description': 'Estime calorias, observe padrões nutricionais e escolha refeições com menos dúvidas.',
  'tool.dream.tag': 'Sonhos',
  'tool.dream.title': 'Interpretação de sonhos',
  'tool.dream.description': 'Organize os símbolos da noite e transforme fragmentos difusos em temas para reflexão.',
  'home.assessments.eyebrow': 'Conheça-se melhor',
  'home.assessments.title': 'Testes de autodescoberta com resultados para explorar',
  'home.assessments.description': 'Faça um teste de personalidade, raciocínio, carreira ou relações e leve o resultado para as conversas com o seu companheiro IA.',
  'home.assessments.action': 'Iniciar teste',
  'home.assessments.disclaimer': 'Estes testes destinam-se a autodescoberta e entretenimento. Não substituem diagnóstico médico ou aconselhamento profissional.',
  'assessment.mbti.eyebrow': 'Personalidade',
  'assessment.mbti.title': 'Teste de personalidade MBTI',
  'assessment.mbti.description': 'Explore preferências, comunicação, pontos fortes e padrões de crescimento.',
  'assessment.mbti.meta': '108 perguntas',
  'assessment.sbti.eyebrow': 'Estilo social',
  'assessment.sbti.title': 'Teste de personalidade SBTI',
  'assessment.sbti.description': 'Descubra como se apresenta aos outros através de cinco dimensões de emoção, ação e energia social.',
  'assessment.sbti.meta': '62 perguntas',
  'assessment.iq.eyebrow': 'Raciocínio',
  'assessment.iq.title': 'Avaliação de raciocínio IQ',
  'assessment.iq.description': 'Resolva padrões não verbais e compare diferentes áreas de raciocínio.',
  'assessment.iq.meta': 'Raciocínio visual',
  'assessment.holland.eyebrow': 'Carreira',
  'assessment.holland.title': 'Interesses profissionais Holland',
  'assessment.holland.description': 'Identifique atividades e ambientes de trabalho que podem ser naturais para si em seis temas.',
  'assessment.holland.meta': 'Interesses profissionais',
  'assessment.attachment.eyebrow': 'Relações',
  'assessment.attachment.title': 'Teste de estilo de vinculação',
  'assessment.attachment.description': 'Reflita sobre proximidade, confiança, segurança e independência para compreender melhor as suas relações.',
  'assessment.attachment.meta': 'Perspetiva relacional',
  'home.guidance.eyebrow': 'Um ritual diário suave',
  'home.guidance.title': 'Orientação mística com IA baseada na reflexão',
  'home.guidance.description': 'Tarot, sorte diária e símbolos dos sonhos ajudam a abrandar, dar nome ao que sente e encontrar um próximo passo possível. O objetivo não é prever o futuro, mas trazer clareza e calma ao presente.',
  'guidance.tarot.title': 'Tarot com IA',
  'guidance.tarot.description': 'Escolha cartas em torno de uma pergunta e use a leitura como um convite suave à reflexão e a uma nova perspetiva.',
  'guidance.tarot.note': 'Para reflexão e entretenimento',
  'guidance.fortune.title': 'Sorte do dia',
  'guidance.fortune.description': 'Comece o dia com um olhar leve sobre humor, energia, sorte e incentivo prático.',
  'guidance.fortune.note': 'Uma nova orientação por dia',
  'guidance.dream.title': 'Interpretação de sonhos',
  'guidance.dream.description': 'Transforme imagens e sentimentos dos sonhos em temas para explorar, sem os tratar como previsões fixas.',
  'guidance.dream.note': 'Símbolos, sentimentos e reflexão',
  'home.features.eyebrow': 'Competências úteis, alegria diária',
  'home.features.title': 'Porque o seu animal se torna tão útil',
  'feature.raise.title': 'Crie animais adoráveis',
  'feature.raise.description': 'Alimente, brinque e veja-os crescer como companheiros ternurentos, reconfortantes e úteis.',
  'feature.hatch.title': 'Faça nascer novas competências',
  'feature.hatch.description': 'Colecione ovos e descubra animais únicos com diferentes personalidades e competências.',
  'feature.coraising.title': 'Crie com os melhores amigos',
  'feature.coraising.description': 'Convide amigos para cuidarem juntos: o dobro do carinho e da diversão.',
  'feature.status.title': 'Estado diário',
  'feature.status.description': 'Registe como se sente e partilhe as emoções com o seu animal.',
  'feature.frequency.title': 'Frequência diária',
  'feature.frequency.description': 'Crie eventos e acompanhe hábitos como beber água, correr e muito mais.',
  'feature.cleaner.title': 'Limpeza de fotografias',
  'feature.cleaner.description': 'Organize a galeria enquanto joga. Divertido e produtivo.',
  'feature.skills.title': 'Sala de competências IA',
  'feature.skills.description': 'Desbloqueie novos visuais e descubra mais ajuda para refletir, planear e viver o quotidiano.',
  'feature.widget.title': 'Widget interativo',
  'feature.widget.description': 'Mantenha o seu animal por perto com widgets interativos no ecrã principal.',
  'home.steps.eyebrow': 'Primeiros passos',
  'home.steps.title': 'Faça nascer um animal com competências úteis',
  'step.adopt.title': 'Adotar',
  'step.adopt.description': 'Escolha o seu ovo único e comece a viagem com um companheiro só seu.',
  'step.grow.title': 'Crescer',
  'step.grow.description': 'Alimente, brinque e interaja todos os dias para o ajudar a crescer e aprender novas competências.',
  'step.together.title': 'Juntos',
  'step.together.description': 'Convide amigos e deixe os animais partilharem um mundo de personalidade e apoio.',
  'home.reviews.eyebrow': 'Comunidade',
  'home.reviews.title': 'Adorado por muito mais do que a sua ternura',
  'home.reviews.role': 'Família do animal',
  'home.news.eyebrow': 'Notícias e histórias',
  'home.news.title': 'Últimas notícias',
  'home.news.description': 'Ideias gentis sobre a vida com o teu pet, autodescoberta e mais bem-estar todos os dias.',
  'home.news.readarticle': 'Ler artigo',
  'home.news.exploreall': 'Ver todas as notícias',
  'review.one.text': 'O meu animal é adorável, mas o que mais me surpreende é a frequência com que uso as suas pequenas competências.',
  'review.two.text': 'Criá-lo com o meu namorado traz-nos alegria e as competências extra são úteis todos os dias.',
  'review.three.text': 'Os widgets são muito interativos. Adoro ter um companheiro querido que também ajuda no quotidiano.',
  'home.footer.tagline': 'Leve alegria e companhia ao seu ecrã principal.',
  'home.footer.product': 'Produto',
  'home.footer.support': 'Apoio',
  'home.footer.social': 'Social',
  'home.footer.skills': 'Competências',
  'home.footer.features': 'Funcionalidades',
  'home.footer.widgets': 'Widgets',
  'home.footer.help': 'Centro de ajuda',
  'home.footer.privacy': 'Privacidade',
  'home.footer.terms': 'Termos',
  'home.footer.copyright': '© 2024 Happy Pet. Todos os direitos reservados.',
  'home.image.logoalt': 'Logótipo Happy Pets',
  'home.image.screenalt': 'Ecrã da aplicação Happy Pets',
  'home.image.enlargedalt': 'Ecrã ampliado do Happy Pets',
  'home.image.close': 'Fechar imagem',
  'invite.headline': 'Os seus amigos convidam-no a criar um animal em conjunto!',
  'invite.description': 'Aceite o convite e o ovo eclode de imediato. Adicione o animal ao ecrã principal.',
  'invite.download': 'Descarregar',
  'invite.loadingalt': 'A carregar Happy Pets',
  'invite.screensalt': 'Capturas da aplicação Happy Pets'
})
